<template>
  <div>
    <div>
      <el-form :inline="true" style="text-align:right;">
        <el-form-item :label="cpnTitle" v-if="cpnShow">
          <el-input class="inputCpn" :size="size" :placeholder="cpnText" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('fuelEfficientDriving.评分等级')+':'"  v-if="levelShow">
          <el-select v-model="level" :size="size">
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('fuelEfficientDriving.异常驾驶行为')+'：'" v-if="abnormalShow">
          <el-select
            v-model="typeValue"
            filterable
            :size="size"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="searchType" :size="size" @input="typeChange()">
            <el-radio-button :label="$t('time.day')"></el-radio-button>
            <el-radio-button :label="$t('time.week')"></el-radio-button>
            <el-radio-button :label="$t('time.month')"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="searchType == $t('time.day')">
          <el-date-picker :size="size"
            v-model="dateDay"
            type="date"
            :picker-options="datePickerOptions"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-show="searchType == $t('time.week')">
          <el-date-picker :size="size"
            v-model="dateWeek"
            :picker-options="datePickerOptions"
            type="week"
            :clearable="false"
            format="yyyy 第 WW 周">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-show="searchType == $t('time.month')">
          <el-date-picker :size="size"
            v-model="dateMonth"
            :picker-options="datePickerOptions"
            value-format="yyyy-MM"
            type="month"
            :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            :size="size"
            style="margin-left:8px;"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    initSearchType:{
      type: String,
      default: "日"
    },
    cpnName: {
      type: Object,
      default: () => ({ 
        title:"参评企业:",
        text:"", 
      }) 
    },
    cpnShow:{
      type: Boolean,
      default: false,
    },
    levelShow:{
      type: Boolean,
      default:false,
    },
    abnormalShow:{
      type:Boolean,
      default:false,
    }
  },
  data(){
    return{
      options: [],
      typeValue: "1",
      levelOptions:[],
      level:"",
      searchType:"日",
      dateDay:new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      dateWeek: new Date().getTime() - 24 * 60 * 60 * 1000,
      dateMonth: new Date(),
      datePickerOptions: {
        'firstDayOfWeek':1,
        disabledDate(date) {
          return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        }
      },
      form:{
        beginDate:"",
        endDate:"",
      },
    }
  },
  computed: {
    cpnTitle(){
      return this.cpnName.title;
    },
    cpnText(){
      return this.cpnName.text;
    },
    size() {
      return this.$store.getters.size
    },
  },
  watch:{
    initSearchType(newVal){
      console.log(newVal);
      this.searchType = newVal;
    }
  },
  methods:{
    handleQuery(){
      switch(this.searchType){
        case this.$t('time.day'):
          this.form.beginDate = this.moment(this.dateDay).format("YYYY-MM-DD");
          this.form.endDate = this.form.beginDate;
          break;
        case this.$t('time.week'):
          console.log(this.dateWeek);
          // element获取的日期是一周的第二天，进行处理
          const weekRange = this.getDay1_7(new Date(this.dateWeek));
          this.form.beginDate = weekRange.start;
          this.form.endDate = weekRange.end;
          break;
        case this.$t('time.month'):
          const monthRange = this.getMonthRangeFromStr(this.dateMonth);
          this.form.beginDate = monthRange.first;
          this.form.endDate = monthRange.last;
          break;
      }
      if(this.levelShow){
        this.form.level = this.level;
      }
      if(this.abnormalShow){
        this.form.typeValue = this.typeValue;
      }
      this.form.initSearchType = this.searchType;
      this.$emit("handleQuery",this.form);
    },
    typeChange(){
      console.log(this.searchType);
      this.handleQuery();
    },
    getDay1_7(prevDay){
      const dayOfWeek = prevDay.getDay(); // 0=周日，1=周一，...，6=周六
      const monday = new Date(prevDay);
      if (dayOfWeek === 0) {
        // 前一天是周日，周一 = 周日 - 6天
        monday.setDate(prevDay.getDate() - 6);
      } else {
        // 其他情况：周一 = 前一天 - (dayOfWeek - 1)天
        monday.setDate(prevDay.getDate() - (dayOfWeek - 1));
      }

      // 3. 计算该周的周日（周一 + 6天）
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      // 格式化结果
      const weekRange = {
        start: this.moment(monday).format("YYYY-MM-DD"), // 周一
        end: this.moment(sunday).format("YYYY-MM-DD")  // 周日
      };
      return weekRange;
    },
    // 从 YYYY-MM 字符串获取当月首尾日期
    getMonthRangeFromStr(ymStr) {
      ymStr = this.moment(ymStr).format("YYYY-MM")
      // 1. 拆分 YYYY 和 MM（如 "2025-10" → ["2025", "10"]）
      const [yearStr, monthStr] = ymStr.split('-');
      const year = parseInt(yearStr, 10);
      // 2. 月份转为 0-11（MM是1-12，减1）
      const month = parseInt(monthStr, 10) - 1;

      // 3. 计算第一天（日期设为1）
      const firstDay = new Date(year, month, 1);
      // 4. 计算最后一天（月份+1，日期设为0）
      const lastDay = new Date(year, month + 1, 0);

      return {
        first: this.moment(firstDay).format("YYYY-MM-DD"), // 当月第一天（YYYY-MM-01）
        last: this.moment(lastDay).format("YYYY-MM-DD")    // 当月最后一天（YYYY-MM-DD）
      };
    }

  },
  mounted(){
    this.searchType = this.$t('time.day');
    this.cpnName.title = this.$t('fuelEfficientDriving.参评企业')+':';
    this.options = [
      { label: this.$t('fuelEfficientDriving.长时间怠速'), value: "1" },
      { label: this.$t('fuelEfficientDriving.急加速'), value: "2" },
      { label: this.$t('fuelEfficientDriving.急减速'), value: "3" },
      { label: this.$t('fuelEfficientDriving.空挡滑行'), value: "4" },
      { label: this.$t('fuelEfficientDriving.超速行驶'), value: "5" },
      { label: this.$t('fuelEfficientDriving.空调温度过低'), value: "6" },
    ];
    this.levelOptions = [
      {value:'',label:this.$t('fuelEfficientDriving.全部')},
      {value:'优秀',label:this.$t('fuelEfficientDriving.优秀')},
      {value:'良好',label:this.$t('fuelEfficientDriving.良好')},
      {value:'中等',label:this.$t('fuelEfficientDriving.中等')},
      {value:'一般',label:this.$t('fuelEfficientDriving.一般')},
      {value:'差',label:this.$t('fuelEfficientDriving.差')},
    ];
    const today = new Date();
    const prevDay = new Date(today);
    prevDay.setDate(today.getDate() - 1);
    this.dateWeek = this.moment(prevDay).format("YYYY-MM-DD") 
    this.$nextTick(()=>{
      this.handleQuery();
    });
  }
}
</script>
<style lang="scss"  scoped>
.inputCpn{
  ::v-deep .el-input__inner{
    background-color: white !important;
    cursor: default  !important;
  }
  ::v-deep .el-input__inner::placeholder {
    color: #0F1A3A; 
    // opacity: 1;
  }
} 
</style>